import styled from 'styled-components';

const FormFieldError = styled.div`
    font-size: .75em
`;

export default FormFieldError;